

































































import TitleBar from "@/components/Elements/TitleBar.vue";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";
import moment from "moment";
import "moment/locale/ru";

import { STORE_KEY, store } from "./_store";

import MultiComponent from "@/components/Controls/MultiComponent.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, ["settings", "loaded", "loading"]),
    ...mapState("ubic", ["actor"])
  },
  methods: {},
  components: {
    TitleBar,
    MultiComponent
  }
})
export default class Settings extends Vue {
  actor!: any;
  filter!: any;
  employees!: any[];

  get titleStack() {
    return ["Настройки"];
  }

  public setValue(group: any, field: any, value: any) {
    this.$store.dispatch(`${STORE_KEY}/setValue`, {
      group,
      field,
      newValue: value
    });
  }

  public saveSetting(group: any) {
    this.$store.dispatch(`${STORE_KEY}/saveSetting`, {
      group
    });
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  opendeSources: any[] = [];

  public mounted() {
    this.handleParamsChange();
  }

  // ---------------------------------------------------------------------------

  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`);
  }
}
